import { render } from "./MermaCreate.vue?vue&type=template&id=0d4e0838&scoped=true"
import script from "./MermaCreate.vue?vue&type=script&lang=js"
export * from "./MermaCreate.vue?vue&type=script&lang=js"

import "./MermaCreate.vue?vue&type=style&index=0&id=0d4e0838&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4e0838"]])

export default __exports__